module.exports = __webpack_public_path__ + "media/images/icons/complete-icon-e9ff3fac42ad78e1a264f08706917621.svg";